export class ObjectUtil {
  static getLatestFieldOfObject = (obj) => {
    return Object.keys(obj)[Object.keys(obj).length - 1];
  };
}
